
<div class="warp">
  <div class="line" [style.height.px]="calculateProgressBarHeight()"></div>
  <ng-container *ngFor="let step of steps; let i = index">
    <span class="flag" [style.top.px]="calculateStepPosition(i)" [class.vertical-flag]="i === 0">{{ step.number }}</span>
  </ng-container>
</div>